/*
  Glooty squat test (sections/glooty-squat-test.liquid)
  - "Watch the squat test" button plays the Shopify video inside the photo frame
    (Dawn's <deferred-media>, defined in global.js).
  - On product pages, keeps "[data-g-color]" in sync with the selected colour
    (Dawn publishes PUB_SUB_EVENTS.variantChange from product-info.js; for a combination with no
    variant, glooty-product.js sends glooty:no-variant with the picked options instead).
*/
if (!customElements.get('glooty-squat-test')) {
  customElements.define(
    'glooty-squat-test',
    class GlootySquatTest extends HTMLElement {
      connectedCallback() {
        this.media = this.querySelector('deferred-media');
        this.onPlayClick = this.onPlayClick.bind(this);
        this.playButtons = Array.from(this.querySelectorAll('[data-g-squat-play]'));
        this.playButtons.forEach((button) => button.addEventListener('click', this.onPlayClick));

        const colorIndex = parseInt(this.dataset.colorIndex, 10);
        if (
          !Number.isNaN(colorIndex) &&
          typeof subscribe === 'function' &&
          typeof PUB_SUB_EVENTS !== 'undefined'
        ) {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            this.updateColor(event, colorIndex);
          });
        }
        if (!Number.isNaN(colorIndex)) {
          this.onNoVariant = (event) => {
            if (event.target !== this.mainInfo()) return;
            const options = event.detail && event.detail.options;
            if (Array.isArray(options)) this.setColor(options[colorIndex]);
          };
          document.addEventListener('glooty:no-variant', this.onNoVariant);
        }
      }

      disconnectedCallback() {
        if (this.playButtons) {
          this.playButtons.forEach((button) => button.removeEventListener('click', this.onPlayClick));
        }
        if (this.unsubscribe) this.unsubscribe();
        if (this.onNoVariant) document.removeEventListener('glooty:no-variant', this.onNoVariant);
      }

      onPlayClick(event) {
        if (!this.media) return;
        event.preventDefault();

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.media.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });

        if (!this.media.getAttribute('loaded') && typeof this.media.loadContent === 'function') {
          this.media.loadContent(false);
        } else {
          const video = this.media.querySelector('video');
          if (video) video.play();
        }

        const player = this.media.querySelector('video, iframe');
        if (player) player.focus({ preventScroll: true });
      }

      // The product of the page, not a quick-add modal (its product-info carries the main section
      // id in data-original-section)
      mainInfo() {
        return document.querySelector('product-info[id^="MainProduct-"]:not([data-original-section])');
      }

      updateColor(event, colorIndex) {
        const variant = event && event.data ? event.data.variant : null;
        if (!variant || !Array.isArray(variant.options)) return;

        // Only follow the product of the page. Quick-add popups and featured-product sections
        // publish the same event for other products, and the modal's product-info even carries the
        // main section id (data-original-section), so match the variant the main form now holds:
        // Dawn writes it into the form before publishing. Forms by id: a complementary products
        // block with quick add has add-to-cart forms of its own inside product-info.
        const main = this.mainInfo();
        const section = main && main.dataset.section;
        const input =
          section &&
          main.querySelector(
            `#product-form-${section} input[name="id"], #product-form-installment-${section} input[name="id"]`
          );
        if (!input || String(variant.id) !== input.value) return;

        this.setColor(variant.options[colorIndex]);
      }

      setColor(value) {
        if (!value) return;
        this.querySelectorAll('[data-g-color]').forEach((element) => {
          element.textContent = value;
        });
      }
    }
  );
}
